export default "__VITE_ASSET__CQ8_NN$W__"